import { createFileRoute, redirect } from '@tanstack/react-router'
import { authService } from '@/auth/service'
import { captureRuntimeClaimFragment } from '@/utils/runtimeClaim'
import { RuntimeClaimPage, type InitialClaim } from '@/features/runtimes/runtime-claim-page'
export const Route = createFileRoute('/runtime-claim')({
  preloadStaleTime: 0,
  beforeLoad: async ({ preload }) => {
    if (preload) return { initial: { code: '', invalid: false } satisfies InitialClaim }
    let initial: InitialClaim
    try { initial = { code: captureRuntimeClaimFragment(window.location, window.history) ?? '', invalid: false } }
    catch { initial = { code: '', invalid: true } }
    if (window.location.search) window.history.replaceState(window.history.state, '', window.location.pathname)
    if (!initial.invalid) {
      const auth = await authService.restore()
      if (['anonymous', 'expired', 'changed-elsewhere'].includes(auth.status)) throw redirect({ to: '/login', search: { redirect: '/runtime-claim' } })
      if (auth.status === 'unsupported') throw redirect({ to: '/browser-gate' })
    }
    return { initial }
  },
  component: ClaimRoute,
})
function ClaimRoute() { const { initial } = Route.useRouteContext(); return <RuntimeClaimPage initial={initial} /> }
